import { withForm } from '@/components/form';
import { SectionCard } from '@/components/ui';
import { organizationFromEmail } from '@/utils/emailDomain';

import type { EmploymentFormItem , employmentTypeEnum } from '../../contactSchema';
import { defaultFormValues } from '../../contactSchema';
import { AddItemButton, RepeaterItem } from './RepeaterItem';

const TYPE_OPTIONS = [
  { value: '', label: '—' },
  { value: 'full-time' as const, label: 'Full-time' },
  { value: 'part-time' as const, label: 'Part-time' },
  { value: 'contract' as const, label: 'Contract' },
  { value: 'internship' as const, label: 'Internship' },
] satisfies { value: (typeof employmentTypeEnum.options)[number]; label: string }[];

const empty = (): EmploymentFormItem => ({ organization: '', role: '' });

export const EmploymentSection = withForm({
  defaultValues: defaultFormValues,
  render: function EmploymentSection({ form }) {
    return (
      <SectionCard
        title="Employment history"
        actions={
          <AddItemButton
            onClick={() => {
              const email = form.getFieldValue('contact.primaryEmail');
              const org = organizationFromEmail(email);
              form.pushFieldValue('employment', { ...empty(), organization: org ?? '' });
            }}
          />
        }
      >
        <form.AppField name="employment">
          {(field) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {(field.state.value ?? []).map((_, i) => (
                <RepeaterItem key={i} onRemove={() => field.removeValue(i)} removeLabel="Remove employment entry">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <div className="ds-form-grid-2">
                      <form.AppField name={`employment[${i}].organization`}>
                        {(f) => <f.TextField label="Organization" required />}
                      </form.AppField>
                      <form.AppField name={`employment[${i}].role`}>
                        {(f) => <f.TextField label="Role" required />}
                      </form.AppField>
                    </div>
                    <div className="ds-form-grid-3">
                      <form.AppField name={`employment[${i}].department`}>
                        {(f) => <f.TextField label="Department" />}
                      </form.AppField>
                      <form.AppField name={`employment[${i}].employmentType`}>
                        {(f) => <f.Select label="Type" options={TYPE_OPTIONS} />}
                      </form.AppField>
                      <form.AppField name={`employment[${i}].location`}>
                        {(f) => <f.TextField label="Location" />}
                      </form.AppField>
                    </div>
                    <div className="ds-form-grid-2">
                      <form.AppField name={`employment[${i}].startDate`}>
                        {(f) => <f.DatePicker label="Start date" />}
                      </form.AppField>
                      <form.AppField name={`employment[${i}].endDate`}>
                        {(f) => <f.DatePicker label="End date" />}
                      </form.AppField>
                    </div>
                    <form.AppField name={`employment[${i}].description`}>
                      {(f) => <f.TextField label="Description" multiline rows={2} />}
                    </form.AppField>
                  </div>
                </RepeaterItem>
              ))}
            </div>
          )}
        </form.AppField>
      </SectionCard>
    );
  },
});
